module.exports = __webpack_public_path__ + "img/fondoVerde.e381e536.png";